export const CONCLUSION_CONSTANTS = {
  button: {
    label: "Get In Touch With Us",
    link: "#contact-us",
  },
  content:
    "Our experts are available 24/7 to help you choose the right service for your needs.",
  title: "Not sure which one to choose? ",
};
